import { h, Host } from "@stencil/core";
export class Dropdown {
    constructor() {
        this.isOpen = false;
        this.activeLabel = null;
        this.selectedCheckboxes = 0;
        this.parentContainerSelector = "";
        this.placeholder = "";
        this.name = "";
        this.filterable = false;
        this.searchPlaceholder = "Search";
        this.hasRadioListItems = false;
        this.hasCheckboxListItems = false;
        this.dropdownListStyles = {
            overflowY: "auto",
            maxHeight: "none"
        };
    }
    baseClass = "ux-dropdown";
    domNode;
    dropdownList;
    parentContainer = null;
    mimimumAcceptableHeight = 200;
    windowBottomPadding = 20;
    handleBodyClick(event) {
        if (!this.domNode.contains(event.target)) {
            this.isOpen = false;
        }
    }
    /** Connect filter */
    setParentContainer() {
        if (this.parentContainerSelector === "") {
            return;
        }
        this.parentContainer = this.domNode.closest(this.parentContainerSelector);
    }
    componentDidLoad() {
        window.requestAnimationFrame(() => {
            this.hasRadioListItems = !!this.dropdownList.querySelector("ux-radio-list-item");
            this.hasCheckboxListItems = !!this.dropdownList.querySelector("ux-checkbox-list-item");
            this.setSelectedCheckboxes();
            this.getActiveLabel();
            this.setParentContainer();
        });
    }
    getActiveLabel = async () => {
        if (!this.hasRadioListItems) {
            return;
        }
        let checkedRadioButton = this.domNode.querySelector("input[type='radio']:checked")?.closest("ux-radio-button");
        if (!checkedRadioButton && this.placeholder === "") {
            const firstRadioListItem = this.domNode.querySelector("input[type='radio']")?.closest("ux-radio-list-item");
            // @ts-expect-error Check for typing
            firstRadioListItem.checked = true;
            // @ts-expect-error Check for typing
            checkedRadioButton = firstRadioListItem.querySelector("ux-radio-button");
        }
        else {
            this.activeLabel = null;
        }
        // @ts-expect-error Check for typing
        this.activeLabel = await checkedRadioButton?.getLabel();
    };
    async handleOneChoice(e) {
        if (!this.hasRadioListItems || !this.dropdownList) {
            return;
        }
        if (!this.dropdownList.contains(e.target)) {
            return;
        }
        this.activeLabel = await e.target.getLabel();
        this.isOpen = false;
    }
    async handleMultipleChoice(e) {
        if (!this.hasCheckboxListItems || !this.dropdownList) {
            return;
        }
        if (!this.dropdownList.contains(e.target)) {
            return;
        }
        this.setSelectedCheckboxes();
    }
    setSelectedCheckboxes = () => {
        if (!this.hasCheckboxListItems || !this.dropdownList) {
            return;
        }
        this.selectedCheckboxes = this.dropdownList.querySelectorAll("input[type='checkbox']:checked").length;
    };
    onLabelClick() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.enableScrollBarOnOverflow();
        }
        else {
            setTimeout(() => {
                if (this.isOpen) {
                    return;
                }
                this.dropdownListStyles = {
                    overflowY: "auto",
                    maxHeight: "none"
                };
            }, 300);
        }
    }
    enableScrollBarOnOverflow() {
        if (this.dropdownList) {
            const scrollHeight = this.dropdownList.scrollHeight;
            const windowHeight = window.innerHeight;
            let availableHeight = 0;
            let isParentContainerDefined = false;
            const listRects = this.dropdownList.getBoundingClientRect();
            const availableDropHeight = windowHeight - listRects.top;
            if (this.parentContainer !== null) {
                const parentRects = this.parentContainer.getBoundingClientRect();
                const listOffsetYToParent = listRects.top - parentRects.top;
                const parentStyles = window.getComputedStyle(this.parentContainer);
                const paddingBottomParent = parseFloat(parentStyles.getPropertyValue("padding-bottom"));
                availableHeight = parentRects.height - listOffsetYToParent - paddingBottomParent;
                isParentContainerDefined = true;
            }
            else {
                availableHeight = availableDropHeight;
            }
            const optimalHeight = !isParentContainerDefined
                ? availableHeight - this.windowBottomPadding
                : availableHeight < availableDropHeight
                    ? availableHeight
                    : availableDropHeight - this.windowBottomPadding;
            const maxHeight = optimalHeight > this.mimimumAcceptableHeight ? optimalHeight : this.mimimumAcceptableHeight;
            if (scrollHeight > maxHeight) {
                this.dropdownListStyles = {
                    overflowY: "scroll",
                    maxHeight: maxHeight + "px"
                };
            }
        }
    }
    render() {
        return (h(Host, { key: '751431778174d0952dc444f3af90f80b52411b05', class: {
                [this.baseClass]: true,
                [`${this.baseClass}--down`]: this.isOpen
            } }, h("button", { key: '42fceff5f12da12ffa969b5b1b5be9dcd6031a56', class: {
                [`${this.baseClass}__label`]: true,
                [`${this.baseClass}__label--light`]: this.hasRadioListItems
            }, onClick: this.onLabelClick.bind(this), type: "button" }, h("span", { key: 'acbae23b121f5fda4b91d00e47409d9567e7ea9e' }, h("span", { key: '7ec8808cf0aae2db5bd2da7f2f4b799b6ce5f376', innerHTML: this.activeLabel || this.placeholder }), this.hasCheckboxListItems && this.selectedCheckboxes > 0 && (h("span", { key: 'ae4ef8a6bfaf031359cd0a3205631c8c26ad3ccb', class: "ux-dropdown__counter" }, this.selectedCheckboxes))), h("ux-icon", { key: '64a8520fd13168dd77212098c67e9fc69bf84d66', name: "chevron-down", weight: "bold" })), h("div", { key: '869cc28e4c2ab251ce5bb4b877b082efebb40407', class: "ux-dropdown__dropdown-locator", "aria-hidden": `${!this.isOpen}` }, h("ux-filterable-list", { key: 'bb3a590c65ccef9e90ed25eb31d06f007a0c0779', inert: !this.isOpen, filterable: this.filterable, "search-placeholder": this.searchPlaceholder, class: {
                [`${this.baseClass}__menu`]: true,
                [`${this.baseClass}__menu--radio-items`]: this.hasRadioListItems
            },
            // @ts-expect-error Check for typing
            ref: (el) => (this.dropdownList = el), style: {
                overflowY: this.dropdownListStyles.overflowY,
                maxHeight: this.dropdownListStyles.maxHeight
            } }, h("slot", { key: '8d80ac4709c4d7a210d19a5383647d4ea7e842d8' })))));
    }
    static get is() { return "ux-dropdown"; }
    static get originalStyleUrls() {
        return {
            "$": ["dropdown.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dropdown.css"]
        };
    }
    static get properties() {
        return {
            "parentContainerSelector": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set parent container to calculate max width of dropdown and activating scrollbar overflow if necessary"
                },
                "attribute": "parent-container-selector",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "placeholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Text displayed inside the Dropdown"
                },
                "attribute": "placeholder",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Name Identifies the dropdown in a bigger context (for example in forms, filters)"
                },
                "attribute": "name",
                "reflect": true,
                "defaultValue": "\"\""
            },
            "filterable": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This toggles the text-input to filter the dropdown items"
                },
                "attribute": "filterable",
                "reflect": true,
                "defaultValue": "false"
            },
            "searchPlaceholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The placeholder string for the search field"
                },
                "attribute": "search-placeholder",
                "reflect": false,
                "defaultValue": "\"Search\""
            }
        };
    }
    static get states() {
        return {
            "isOpen": {},
            "activeLabel": {},
            "selectedCheckboxes": {},
            "hasRadioListItems": {},
            "hasCheckboxListItems": {},
            "dropdownListStyles": {}
        };
    }
    static get elementRef() { return "domNode"; }
    static get watchers() {
        return [{
                "propName": "parentContainerSelector",
                "methodName": "setParentContainer"
            }];
    }
    static get listeners() {
        return [{
                "name": "click",
                "method": "handleBodyClick",
                "target": "body",
                "capture": false,
                "passive": false
            }, {
                "name": "uxRadioButtonChange",
                "method": "handleOneChoice",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "uxCheckboxListItemChange",
                "method": "handleMultipleChoice",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=dropdown.js.map
